import { SeatUsageFragment } from "@/apollo/types";

export const SEAT_HELD_BY_INVITATION_NOTE =
  "A pending invitation holds a seat until it is accepted, deleted, or expires.";

function count(n: number, noun: string) {
  return `${n} ${noun}${n === 1 ? "" : "s"}`;
}

export function formatSeatBreakdown(usage: SeatUsageFragment) {
  if (usage.pendingInvitations === 0) {
    return null;
  }
  return `${count(usage.members, "member")} + ${count(
    usage.pendingInvitations,
    "pending invitation",
  )}`;
}

export function formatSeatUsage(usage: SeatUsageFragment) {
  const used =
    usage.limit == null
      ? `${usage.used} seats used`
      : `${usage.used} of ${usage.limit} seats used`;

  const breakdown = formatSeatBreakdown(usage);
  return breakdown == null ? used : `${used} (${breakdown})`;
}
